import type { QueryClient, QueryKey } from '@tanstack/react-query';
import { DEFAULT_CONTENT_LOCALE } from '@course-authoring/shared-types';

export const lessonDetailsQueryRoot = ['lessons', 'detail'] as const;

export const courseLearnerPreviewKeys = {
  all: ['courseLearnerPreview'] as const,
  detail: (courseId: string, locale = DEFAULT_CONTENT_LOCALE, accountId: number | null = null) =>
    [...courseLearnerPreviewKeys.all, courseId, locale, accountId ?? 'base'] as const,
};

export function invalidateLessonLocaleCoverage(
  queryClient: QueryClient,
  lessonDetailQueryKey: QueryKey = lessonDetailsQueryRoot,
): void {
  void queryClient.invalidateQueries({ queryKey: lessonDetailQueryKey });
  void queryClient.invalidateQueries({ queryKey: courseLearnerPreviewKeys.all });
}
